import React from 'react';
import { useFeatureFlag } from '@/context/FeatureFlagContext';

export const FeatureFlagDebug: React.FC = () => {
  const { flags, loading, error } = useFeatureFlag();

  // Only show in development
  if (import.meta.env.PROD) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: '10px',
      right: '10px',
      background: '#1a1a1a',
      color: '#fff',
      padding: '12px',
      borderRadius: '8px',
      fontSize: '12px',
      fontFamily: 'monospace',
      maxWidth: '300px',
      zIndex: 9999,
      boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
    }}>
      <div style={{ fontWeight: 'bold', marginBottom: '8px', color: '#4ade80' }}>
        🚩 Feature Flags Debug
      </div>
      {loading && <div style={{ color: '#fbbf24' }}>Loading...</div>}
      {error && <div style={{ color: '#f87171' }}>Error: {error}</div>}
      {!loading && (
        <div>
          {Object.entries(flags).length === 0 ? (
            <div style={{ color: '#9ca3af' }}>No flags configured</div>
          ) : (
            Object.entries(flags).map(([key, value]) => (
              <div key={key} style={{ marginBottom: '4px' }}>
                <span style={{ color: value ? '#4ade80' : '#f87171' }}>
                  {value ? '✅' : '❌'}
                </span>
                {' '}
                <span style={{ color: '#93c5fd' }}>{key}</span>
                {': '}
                <span style={{ color: value ? '#4ade80' : '#f87171' }}>
                  {String(value)}
                </span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};
